import { trimStart } from 'lodash';
import { thumborURL } from 'react-thumbor-img';
import { getBaseImagePath, getThumborEndpoint, isDevBox, isDevEnvironment } from 'utils/environment-util';
import { roundAndScale } from './roundAndScale';
import { ThumborImgUrlProps } from './types';

const MAX_IMAGE_SCALE = 2;
const DEFAULT_DEVICE_PIXEL_RATIO = 1;

export const generateThumborImgUrl = ({ src, width, height, bucketSize = 50 }: ThumborImgUrlProps): string => {
  if (src.startsWith('data:')) {
    return src;
  }

  const absolutePathExp = /^https?:\/\//i;
  const baseImagePath = getBaseImagePath();
  const computedSrc = absolutePathExp.test(src) ? src : `${baseImagePath}/${trimStart(src, '/')}`;

  if (isDevEnvironment() && !isDevBox()) {
    return computedSrc;
  }

  const devicePixelRatio = typeof window === 'undefined' ? DEFAULT_DEVICE_PIXEL_RATIO : window.devicePixelRatio;
  const scale = Math.min(devicePixelRatio, MAX_IMAGE_SCALE);

  const sourceWidthBeforeRounding = Math.ceil((width ?? 0) * scale);
  const sourceHeightBeforeRounding = Math.ceil((height ?? 0) * scale);
  const [sourceWidth, sourceHeight] = roundAndScale(
    [sourceWidthBeforeRounding, sourceHeightBeforeRounding],
    bucketSize
  );

  const thumborImg = {
    server: getThumborEndpoint(),
    src: computedSrc,
    width: sourceWidth,
    height: sourceHeight,
  };

  return thumborURL(thumborImg);
};
